export default "__VITE_ASSET__QFscUO0q__"